'use client';

import { useEffect } from 'react';
import Script from 'next/script';
import { useTranslations } from 'next-intl';

export default function PaymentGateways({ formState, gateWay, setGateway }) {
  const t = useTranslations('buyNow');
  // Effect to update the Payment details with the customer data
  useEffect(() => {
    if (formState.success) {
      sessionStorage.setItem('userDetails', JSON.stringify(formState.data));
    }
  }, [formState]);

  const handleOptionChange = (event) => {
    setGateway(event.target.value);
  };

  return (
    <div className="content-start my-2">
      <div className=" w-1/2 justify-start flex flex-col gap-3">
        <div>
          <p>{t('payoptions')}</p>
        </div>
        <div
          className={`shadow-md gap-2 rounded-md flex flex-row items-center bg-white p-2 hover:shadow-xl border border-gray-300 ${
            gateWay === 'razorPay'
              ? 'outline-2 outline-blue-500/50 shadow-xl'
              : ''
          }`}
        >
          <input
            type="radio"
            className="text-blue-600 scale-75 focus:ring-blue-600 rounded-full cursor-pointer"
            name="gatewayOption"
            id="razorpay"
            value={'razorPay'}
            checked={gateWay === 'razorPay'}
            onChange={handleOptionChange}
          />
          <label
            className={
              'rounded w-full h-full flex p-4 bg-[url(/paymentrazorpay.webp)] bg-center bg-cover cursor-pointer'
            }
            htmlFor="razorpay"
          ></label>
        </div>
        <div
          className={`shadow-md gap-2 rounded-md flex flex-row items-center p-2 bg-white hover:shadow-xl border border-gray-300 ${
            gateWay === 'ccAvenue'
              ? 'outline-2 outline-blue-500/50 shadow-xl'
              : ''
          }`}
        >
          <input
            type="radio"
            className="text-blue-600 scale-75 focus:ring-blue-600 rounded-full cursor-pointer"
            name="gatewayOption"
            id="ccavenue"
            value={'ccAvenue'}
            checked={gateWay === 'ccAvenue'}
            onChange={handleOptionChange}
          />
          <label
            className={
              'rounded w-full h-full flex p-4 bg-[url(/paymentcca.webp)] bg-contain bg-center bg-no-repeat cursor-pointer'
            }
            htmlFor="ccavenue"
          ></label>
        </div>
        <div
          className={`shadow-md bg-white gap-2 rounded-md flex flex-row items-center p-2 hover:shadow-xl border border-gray-300 ${
            gateWay === 'payPal'
              ? 'outline-2 outline-blue-500/50 shadow-xl'
              : ''
          }`}
        >
          <input
            type="radio"
            className="text-blue-600 scale-75 focus:ring-blue-600 rounded-full cursor-pointer"
            name="gatewayOption"
            id="paypal"
            value={'payPal'}
            checked={gateWay === 'payPal'}
            onChange={handleOptionChange}
          />
          <label
            className={
              'rounded w-full h-full flex p-4 bg-[url(/paypal-img.webp)] bg-cover bg-center bg-no-repeat cursor-pointer'
            }
            htmlFor="paypal"
          ></label>
        </div>
      </div>
      <Script src="https://checkout.razorpay.com/v1/checkout.js" />
    </div>
  );
}
